module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-formGreen-579a158ff8ab2921a5c9d90dc8544d71.svg";